import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { PaginationParams } from "../../users.type";
import { PaginationTypeProps } from "@/components/data-table/types/pagination-type-props";

export function DataTablePagination({
  currentPage,
  setCurrentPage,
  totalPage,
}: Required<Pick<PaginationTypeProps, "totalPage">> & {
  currentPage: PaginationParams;
  setCurrentPage: (page: number) => void;
}) {
  const goToPage = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="flex items-center justify-end space-x-2 py-4">
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex w-[100px] items-center justify-center text-sm font-medium">
          Page {currentPage.pageIndex} of {totalPage}
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            className="size-9 p-0 items-center justify-center rounded-md border border-border focus-visible:ring-0 focus-visible:border-border"
            onClick={() => goToPage(1)}
            disabled={currentPage.pageIndex === 1}
          >
            <ChevronsLeft className="h-4 w-4" />
          </Button>

          <Button
            variant="outline"
            className="size-9 p-0 items-center justify-center rounded-md border border-border focus-visible:ring-0 focus-visible:border-border"
            onClick={() => goToPage(Math.max(1, (currentPage.pageIndex ?? 1) - 1))}
            disabled={currentPage.pageIndex === 1}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          <Button
            variant="outline"
            className="size-9 p-0 items-center justify-center rounded-md border border-border focus-visible:ring-0 focus-visible:border-border"
            onClick={() => goToPage(Math.min(totalPage, (currentPage.pageIndex ?? 1) + 1))}
            disabled={currentPage.pageIndex === totalPage}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>

          <Button
            variant="outline"
            className="size-9 p-0 items-center justify-center rounded-md border border-border focus-visible:ring-0 focus-visible:border-border"
            onClick={() => goToPage(totalPage)}
            disabled={currentPage.pageIndex === totalPage}
          >
            <ChevronsRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
